import { Dialog, DialogContent, DialogContentText, Tooltip } from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";
import CurrencyFormat from "react-currency-format";
import { CgClose } from "react-icons/cg";
import { IoClose, IoInformationCircleSharp } from "react-icons/io5";
import MinimumBasketImage from "../../../assets/minimumBasketImage.svg";
import { useNavigate } from "react-router-dom";
import RxjsGiftStoreContext from "../../../context/RxjsGiftStoreContext";
import CherriesImage from "../../../assets/cherriesImage.png";
import { Transition, Dialog as DailogUi } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { authService } from "../../../services/authService";
import { fetchGrocedyForAll } from "../../../store/actions";
import { CurrencyComponent } from "../../../core/helpers";

const GiftCartSummary = ({
    customGiftFoodBasket,
    calculateTotalBasket,
    customGiftBasket,
    handleCouponVerifyGift,
    setCouponCodeGift,
    couponCodeGift,
    handleGiftGeneralCheckout,
    priceAlertGift,
    showPriceAlertGift,
    hybridDeliveryFeeGift,
    deliveryFeeLoadingGift
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [grochilsSectionModal, setGrochilsSectionModal] = useState(false);
    const [allGrochillProductList, setAllGrochillProductList] = useState([]);
    const [isMissingCustom, setIsMissingCustom] = useState(false);
    const [isMissingFB, setIsMissingFB] = useState(false);
    const [fetchedProducts, setFectchedProducts] = useState([]);
    const [fetchedPlans, setFetchedPlans] = useState([]);
    const rxjsStore = useContext(RxjsGiftStoreContext);
    const { grocedyForAll } = useSelector((state) => state.masterData);
    const customerId = authService.getCurrentUserCustomerId();

    useEffect(() => {
        rxjsStore.getAllButcherProductList().subscribe((allProduct) => {
            setAllGrochillProductList(allProduct);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (grocedyForAll?.plan_info?.length) {
            setFetchedPlans(grocedyForAll?.plan_info);
        }
    }, [grocedyForAll]);

    useEffect(() => {
        if (!grocedyForAll) {
            dispatch(fetchGrocedyForAll(customerId ? customerId : "0"))
                .unwrap()
                .catch((err) => {
                    return err;
                });
        } else {
            const filterProductId = grocedyForAll?.product_info
                ?.filter((pp) => pp?.product_id === "1")
                .pop();

            // Only update if product actually changed
            if (
                filterProductId &&
                filterProductId?.product_id !== fetchedProducts?.product_id
            ) {
                setFectchedProducts(filterProductId);
            }
        }
    }, [grocedyForAll, customerId, dispatch, fetchedProducts]);

    useEffect(() => {
        if (!customGiftBasket?.line_items?.length && customGiftFoodBasket?.line_items?.length) {
            setGrochilsSectionModal(true);
            setIsMissingCustom(true);
        } else if (customGiftBasket?.line_items && customGiftFoodBasket?.line_items?.length) {
            setGrochilsSectionModal(false);
            setIsMissingCustom(false);
        } else if (customGiftBasket?.line_items && !customGiftFoodBasket?.line_items?.length) {
            setGrochilsSectionModal(true);
            setIsMissingFB(true);
        }
    }, [customGiftBasket?.line_items, customGiftFoodBasket?.line_items]);

    return (
        <div className='px-2 xsm:px-4 sm:px-8 lg:px-0 w-full pb-40 bg-white lg:col-span-3 '>
            <div className='pt-8 lg:pt-4 mb-6 px-4'>
                <h2 className='text-lg font-bold text-gray-600'>Gift Order Summary</h2>
                {customGiftFoodBasket && customGiftFoodBasket?.line_items?.length ? (
                    <div className='mt-8'>
                        <div className='flex flex-row justify-between text-gray-700'>
                            <div className='mr-2 max-w-xs'>
                                <h4 className='text-sm font-medium'>{customGiftFoodBasket?.plan_name}</h4>
                                {/* <p className='text-xs'>Quantity</p> */}
                            </div>
                            <div className='text-base font-semibold'>
                                <CurrencyFormat
                                    value={Number.parseFloat(
                                        calculateTotalBasket(customGiftFoodBasket)
                                    )?.toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"₦"}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}

                {customGiftBasket && customGiftBasket?.line_items?.length ? (
                    <div className='mt-8'>
                        <div className='flex flex-row justify-between text-gray-700'>
                            <div className='mr-2 max-w-xs'>
                                <h4 className='text-sm font-medium'>{customGiftBasket?.plan_name}</h4>
                                <p className='text-xs'>Quantity</p>
                            </div>
                            <div className='text-base font-semibold'>
                                <CurrencyFormat
                                    value={Number.parseFloat(
                                        calculateTotalBasket(customGiftBasket)
                                    )?.toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"₦"}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
            <div className='h-[1.5px] w-full bg-[#DFE5D1]' />
            <div className="mt-10 px-4">
                <form onSubmit={handleCouponVerifyGift}>
                    <label className="ml-1 text-base font-semibold text-gray-700">
                        Coupon
                    </label>
                    <div className="mt-2 flex justify-between space-x-2">
                        <input
                            onChange={(e) => setCouponCodeGift(e.target.value)}
                            value={couponCodeGift}
                            type="text"
                            placeholder="Input coupon code"
                            className="h-11 border-none flex-1 rounded-md ring-gray-300 bg-white text-base placeholder:text-base placeholder:text-gray-400 focus:outline-none focus:border-none ring-1  focus:ring-2 focus:ring-olivine-500"
                        />
                        <button className="rounded-md border-[1px] border-[#8DAA6A] bg-[#E7EBE3] px-2 py-2.5 font-medium text-olivine-500 hover:bg-olivine-100 xsm:px-4 text-sm">
                            Apply Code
                        </button>
                    </div>
                </form>
            </div>
            <div className='mt-12 px-4'>
                <div className='px-2 flex flex-row items-center justify-between text-gray-700'>
                    <p className=" text-mine-shaft-500 font-medium">Items Total</p>
                    <p className='font-semibold text-base'>
                        {deliveryFeeLoadingGift && !hybridDeliveryFeeGift?.amount_information?.length ? (
                            <p className='font-normal text-xs'>calculating fees...</p>
                        ) : (
                            hybridDeliveryFeeGift?.amount_information ? (
                                <p className='font-semibold text-base'>{`₦${Number(
                                    hybridDeliveryFeeGift?.amount_information?.length && hybridDeliveryFeeGift?.amount_information[0]?.total_item_amount
                                ).toLocaleString()}`}</p>
                            ) : (
                                <p className='font-semibold text-base'>{`₦${Number(0).toLocaleString()}`}</p>
                            )
                        )}
                    </p>
                </div>
                <div className='mt-1 px-2 flex flex-row items-center justify-between text-gray-700'>
                    <p className='flex items-center space-x-3 text-mine-shaft-500 font-medium'>Delivery Fees
                        <Tooltip title="Delivery Fees">
                            <span className='mt-[2px]'>
                                <IoInformationCircleSharp className='h-5 w-5 text-[#558223]' />
                            </span>
                        </Tooltip>
                    </p>
                    {deliveryFeeLoadingGift && !hybridDeliveryFeeGift?.amount_information?.length ? (
                        <p className='font-normal text-xs'>calculating fees...</p>
                    ) : (
                        hybridDeliveryFeeGift?.amount_information ? (
                            <p className='font-semibold text-base'>{`₦${Number(hybridDeliveryFeeGift?.amount_information?.length && hybridDeliveryFeeGift?.amount_information[0]?.total_delivery_charge).toLocaleString()}`}</p>
                        ) : (
                            <p className='font-semibold text-base'>{`₦${Number(0).toLocaleString()}`}</p>
                        )
                    )}
                </div>
                <div className='mt-1 px-2 flex flex-row items-center justify-between text-gray-700'>
                    <p className=' text-mine-shaft-500 font-medium'>Coupon</p>
                    <p className='text-[#E81414] font-semibold text-base'>
                        {deliveryFeeLoadingGift && !hybridDeliveryFeeGift?.amount_information?.length ? (
                            <p className='font-normal text-xs'>calculating fees...</p>
                        ) : (
                            hybridDeliveryFeeGift?.amount_information ? (
                                <p className='font-semibold text-base'>{`- ₦${Number(hybridDeliveryFeeGift?.amount_information?.length && hybridDeliveryFeeGift?.amount_information[0]?.discount_amount).toLocaleString()}`}</p>
                            ) : (
                                <p className='font-semibold text-base'>{`- ₦${Number(0).toLocaleString()}`}</p>
                            )
                        )}
                    </p>
                </div>
                <div className='mt-2 px-2 flex flex-row items-center justify-between text-xl font-bold text-gray-700'>
                    <p>Total</p>
                    <p>

                        {deliveryFeeLoadingGift && !hybridDeliveryFeeGift?.amount_information?.length ? (
                            <p className='font-normal text-xs'>calculating fees...</p>
                        ) : (
                            hybridDeliveryFeeGift?.amount_information ? (
                                <p className='font-semibold text-base'>{`₦${Number(hybridDeliveryFeeGift?.amount_information?.length && hybridDeliveryFeeGift?.amount_information[0]?.grand_total_amount).toLocaleString()}`}</p>
                            ) : (
                                <p className='font-semibold text-base'>{`₦${Number(0).toLocaleString()}`}</p>
                            )
                        )}
                    </p>
                </div>

                {/*  Price Alert */}
                {priceAlertGift && (
                    <div>
                        <Dialog
                            className="h-full"
                            open={true}
                            onClose={() => showPriceAlertGift(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <div className="h-hug w-full rounded-md border-gray-300 bg-gray-100 shadow shadow-gray-400">
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <div className="flex items-center justify-end">
                                            <button
                                                onClick={() => showPriceAlertGift(false)}
                                                className="rounded-full p-2 active:bg-gray-200"
                                            >
                                                <CgClose className="h-5 w-5 text-gravel-500" />
                                            </button>
                                        </div>
                                        <div className="mt-2 flex justify-start text-sm">
                                            <img
                                                src={MinimumBasketImage}
                                                className="h-32 w-full"
                                                alt=""
                                            />
                                        </div>
                                        <div className="cursor mt-4 flex justify-center text-base font-semibold xsm:text-lg ">
                                            <div className=" font-bold text-gray-800">Note</div>
                                        </div>
                                        <div className="mt-2 max-w-md text-center text-xs">
                                            <div className="text-gray-500">
                                                "Please note that our minimum purchase amount is N15,000.
                                                Unfortunately, your current basket value does not meet
                                                this requirement. To proceed with your purchase, kindly
                                                add more items to your basket."
                                            </div>
                                        </div>
                                        <div className="mt-5 pb-4 text-center tracking-wider xsm:px-6 sm:px-16">
                                            <div
                                                onClick={() => showPriceAlertGift(false)}
                                                className="!cursor-pointer rounded-md border-[1px] border-olivine-500 px-6 py-2 text-sm font-semibold text-olivine-500 transition-all duration-200 focus:outline-none focus:ring-[2px] focus:ring-olivine-500 focus:ring-opacity-60 focus:ring-offset-1 active:bg-olivine-100 active:ring-1 active:ring-olivine-500"
                                            >
                                                Continue shopping
                                            </div>
                                        </div>
                                    </DialogContentText>
                                </DialogContent>
                            </div>
                        </Dialog>
                    </div>
                )}
                <button onClick={() => handleGiftGeneralCheckout()} className='mt-10 w-full py-3.5 text-sm font-medium bg-[#8DAA6A] text-white rounded-md hover:bg-[#8DAA6A]/80 active:bg-[#8DAA6A] active:ring-2 active:ring-[#8DAA6A] active:ring-offset-2 transition-all duration-400 ease-in-out'>
                    Proceed to Payment
                </button>
            </div>

            {/* show Shop from our Grochills section modal */}
            <Transition appear show={grochilsSectionModal} as={Fragment}>
                <DailogUi
                    as="div"
                    className="relative z-50"
                    onClose={() => setGrochilsSectionModal(false)}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <DailogUi.Panel className="w-full max-w-xl transform overflow-hidden rounded-xl bg-[#F0F0F0] text-left align-middle shadow-xl transition-all">
                                    <div className="scrollbar-thumb-[#1a3517] scrollbar-track-[#265426] h-fit max-h-[95vh] overflow-y-scroll p-2 scrollbar-thin">
                                        <div
                                            onClick={() =>
                                                setGrochilsSectionModal(
                                                    !grochilsSectionModal
                                                )
                                            }
                                            className="fixed right-3 top-2.5 z-40 w-fit cursor-pointer rounded-full bg-gray-800 p-1.5 text-white hover:bg-gray-600 active:bg-gray-700 transition-all duration-200"
                                        >
                                            <IoClose className="h-5 w-5" />
                                        </div>
                                        <div className="px-3 w-full max-w-lg mx-auto mb-6">
                                            <h2 className="mt-10 text-[min(5vw,28px)] font-bold text-center text-gray-700 leading-tight">
                                                {isMissingFB ? "Explore Food Basket." : "Your Basket's Almost There"}
                                            </h2>
                                            <p className="mt-1 text-center text-[min(4vw,15px)] font-medium text-gray-500 leading-tight">
                                                {isMissingFB ? "Curated baskets picked just for you." : "Shop your frozen essentials such as beef, chicken, etc."}
                                            </p>
                                            <div className="mt-6 w-full max-w-lg mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4">

                                                {isMissingCustom && (
                                                    allGrochillProductList && allGrochillProductList?.length ?
                                                        allGrochillProductList?.slice(0, 4).map((prod) => (
                                                            <div className="flex flex-row items-center space-x-2 bg-white p-3 rounded-md shadow-sm">
                                                                <img src={CherriesImage} alt="img" className="size-20 aspect-auto object-cover" />
                                                                <div>
                                                                    <h3 className="text-xs font-medium text-gray-700">{prod?.name}</h3>
                                                                    <p className="text-sm font-bold text-gray-700">
                                                                        {`₦ ${Number.parseFloat(prod?.item_rate_zoho)?.toFixed(2)}`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )) : null
                                                )}

                                                {isMissingFB && (
                                                    fetchedPlans && fetchedPlans?.length ?
                                                        fetchedPlans?.slice(0, 4).map((prod) => (
                                                            <div className="flex flex-row items-center space-x-2 bg-white p-3 rounded-md shadow-sm">
                                                                <img src={CherriesImage} alt="img" className="size-20 aspect-auto object-cover" />
                                                                <div>
                                                                    <h3 className="text-xs font-medium text-gray-700">{prod?.description}</h3>
                                                                    <p className="text-sm font-bold text-gray-700">
                                                                        {CurrencyComponent(prod?.recurring_price)}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )) : null
                                                )}
                                            </div>
                                            <button onClick={() => navigate(isMissingFB ? `/gift-a-plan` : "/gift-a-basket#grochill")} className="mt-8 w-full transform cursor-pointer rounded-md bg-[#558223] px-6 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-olivine-500/80 focus:outline-none active:bg-olivine-600 @sm:mt-0 @sm:max-w-[200px]">
                                                {isMissingFB ? "Go to Food Baskets" : "Go to GroChills"}
                                            </button>
                                        </div>
                                    </div>
                                </DailogUi.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </DailogUi>
            </Transition>
        </div>
    )
}

export default GiftCartSummary;